import {GET_REVIEW,FETCHREVIEW,DELETE,CREATEREVIEW} from '../constants/actionTypes';


export default  (review=[],action) => {
    switch (action.type) {
        case GET_REVIEW:
                return action.payload;
        case CREATEREVIEW :
            return [...review,action.payload];
        case DELETE:
                return review.filter((message) => message._id !== action.payload);
        default:
            return review;
    }
};